const RECOMMENDATIONS_HEADING_PREFIX = 'كتب ذات صلة';
const RECOMMENDATIONS_HEADING =
  /كتب\s+ذات\s+صلة\s+يمكنك\s+سؤالها\s+مباشرة\s+بذكر\s+حسابها\s*:\s*/u;
const RECOMMENDATION =
  /📖\s*@\s*([A-Za-z0-9_]+(?:\s*@\s*[A-Za-z0-9.-]+)?)\s*[—–-]\s*(.*?)(?=\s*📖\s*@\s*[A-Za-z0-9_]+|$)/gu;
const SHOW_TEXT = 4;

const removeRecommendationSuffix = (document, headingOffset) => {
  const walker = document.createTreeWalker(document.body, SHOW_TEXT);
  let traversed = 0;
  let textNode = walker.nextNode();

  while (textNode) {
    const end = traversed + textNode.data.length;

    if (headingOffset <= end) {
      const range = document.createRange();
      range.setStart(textNode, headingOffset - traversed);
      range.setEndAfter(document.body.lastChild);
      range.deleteContents();
      textNode.data = textNode.data.trimEnd();
      break;
    }

    traversed = end;
    textNode = walker.nextNode();
  }

  document.body.querySelectorAll('p').forEach((paragraph) => {
    if (!paragraph.textContent?.trim() && paragraph.children.length === 0) {
      paragraph.remove();
    }
  });
};

/**
 * Separate the machine-generated recommendation suffix from a Library reply.
 * This accepts both the intended paragraph format and the flattened text
 * emitted by the mention-handler's current NLTK reply chunker.
 * @param {string} html Status HTML returned by the Mastodon API.
 */
export const parseLibraryRecommendations = (html) => {
  if (
    !html ||
    !html.includes(RECOMMENDATIONS_HEADING_PREFIX) ||
    typeof DOMParser === 'undefined'
  ) {
    return null;
  }

  const document = new DOMParser().parseFromString(html, 'text/html');
  const text = document.body.textContent ?? '';
  const heading = RECOMMENDATIONS_HEADING.exec(text);

  if (!heading) {
    return null;
  }

  const recommendations = Array.from(
    text.slice(heading.index + heading[0].length).matchAll(RECOMMENDATION),
    (match) => ({
      acct: match[1].replace(/\s/g, ''),
      title: match[2].trim(),
    }),
  ).filter(({ acct, title }) => acct && title);

  if (recommendations.length === 0) {
    return null;
  }

  removeRecommendationSuffix(document, heading.index);

  return {
    content: document.body.innerHTML.trim(),
    recommendations,
  };
};
